import { generatePath, Link } from 'react-router-dom'
import styled from 'styled-components'

import ButtonV2 from 'components/button-v2'

import { Horizontal } from 'components/layout'
import ROUTING_PATH from 'constants/route'
import { Contract, Feature } from 'schema/contract'
import { UserRole } from 'schema/user'

const DetailLinksLayoutPc = styled(Horizontal)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const DetailLinks = styled(Horizontal)`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    flex-wrap: wrap;
  }
`

const DetailLink = styled(Link)`
  color: ${(p) => p.theme.FONT_COLOR};
  font-size: ${(p) => p.theme.font.size.m};
  height: 72px;
  font-weight: 400;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }
`

const DetailAnnotation = styled(Horizontal)`
  margin-top: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  color: #463e28;
`

interface DetailLinksComponentProps {
  data: Contract | Feature | null
  type: string | null
  isContract: boolean
  isOwner: boolean
  userRole: UserRole | null
  detailAnnotation: string
  isSp?: boolean
}

const DetailLinksComponent = ({
  data,
  type,
  isContract,
  isOwner,
  userRole,
  detailAnnotation,
  isSp = false,
}: DetailLinksComponentProps) => {
  if (!data) {
    return null
  }

  const SuumoDetailLink = (() => {
    const destination =
      userRole === UserRole.OWNER ? ROUTING_PATH.B0304 : ROUTING_PATH.C0304
    return generatePath(destination, { id: data?.id })
  })()

  const AtHomeDetailLink = (() => {
    const destination =
      userRole === UserRole.OWNER ? ROUTING_PATH.B0305 : ROUTING_PATH.C0305
    return generatePath(destination, { id: data?.id })
  })()

  const toReinsDetailPage = generatePath(
    userRole === UserRole.OWNER
      ? ROUTING_PATH.OwnerContractOther
      : ROUTING_PATH.AgentContractOther,
    { id: data.id }
  )

  if (!isSp) {
    return (
      <DetailLinksLayoutPc>
        <DetailLinks gap={8}>
          {data?.suumo && (
            <ButtonV2
              variant="secondary"
              size="sm"
              as={Link}
              to={`${SuumoDetailLink}?type=${type}`}
            >
              suumoの詳細データ
            </ButtonV2>
          )}
          {data?.athome && (
            <ButtonV2
              variant="secondary"
              size="sm"
              as={Link}
              to={`${AtHomeDetailLink}?type=${type}`}
            >
              athomeの詳細データ
            </ButtonV2>
          )}
          {isContract && (data as Contract)?.isPublishedReins && (
            <ButtonV2
              variant="secondary"
              size="sm"
              as={Link}
              to={`${toReinsDetailPage}`}
            >
              {isOwner
                ? '業者からの問い合わせデータ'
                : 'フリエde物確からの問い合わせデータ'}
            </ButtonV2>
          )}
        </DetailLinks>
        <DetailAnnotation>{detailAnnotation}</DetailAnnotation>
      </DetailLinksLayoutPc>
    )
  }
  return (
    <>
      <DetailLinks>
        {data?.suumo && (
          <DetailLink to={`${SuumoDetailLink}?type=${type}`}>
            suumo 詳細データ
            <img
              src="/image/arrow-right-gray.svg"
              alt="suumo"
              width="12"
              height="12"
            />
          </DetailLink>
        )}
        {data?.athome && (
          <DetailLink to={`${AtHomeDetailLink}?type=${type}`}>
            athome 詳細データ
            <img
              src="/image/arrow-right-gray.svg"
              alt="athome"
              width="12"
              height="12"
            />
          </DetailLink>
        )}
        {isContract && (data as Contract)?.isPublishedReins && (
          <DetailLink to={`${toReinsDetailPage}`}>
            {isOwner
              ? '業者からの問い合わせデータ'
              : 'フリエde物確からの問い合わせデータ'}
            <img
              src="/image/arrow-right-gray.svg"
              alt=""
              width="12"
              height="12"
            />
          </DetailLink>
        )}
      </DetailLinks>
    </>
  )
}

export default DetailLinksComponent
